import { common as itCommon } from './it/common';
import { common as enCommon } from './en/common';
import { common as esCommon } from './es/common';
import { common as frCommon } from './fr/common';
import { common as deCommon } from './de/common';

export const resources = {
  it: {
    common: itCommon,
  },
  en: {
    common: enCommon,
  },
  es: {
    common: esCommon,
  },
  fr: {
    common: frCommon,
  },
  de: {
    common: deCommon,
  },
};
